const SpinnerComponentStyle = {
    baseStyle: {
        color: 'primary500',
    },
};
export default SpinnerComponentStyle;
